import { render } from "./Coins.vue?vue&type=template&id=750af4b5"
import script from "./Coins.vue?vue&type=script&lang=js"
export * from "./Coins.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__